import axios from 'axios';
import { CookiesProviderTypes } from './cookies.types';

export function setProviderCookiePreference(
  type: CookiesProviderTypes,
  value: boolean,
) {
  return setMultipleProviderCookiesPreference([type], [value]);
}

export function setMultipleProviderCookiesPreference(
  types: Array<CookiesProviderTypes>,
  values: Array<boolean>,
) {
  return axios.post('/set_cookie_right', {
    cookie_name: types,
    cookie_enabled: values,
  });
}
